module.exports = __webpack_public_path__ + "media/images/cog-b5773a246edcbd0cd6d4cc3584dfb374.svg";